import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { EventsService } from 'src/app/services/events-service/events.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-event-maintenance-card',
  templateUrl: './events-event-maintenance-card.component.html',
  styleUrls: ['./events-event-maintenance-card.component.scss']
})
export class EventsEventMaintenanceCardComponent implements OnInit, OnChanges {

  @Input() alert;
  JSON;
  maintenanceAlerts = [
    { type: ['LOW_BATERY', 'DEVICE_BATTERY_LEVEL'], value: false },
    { type: ['DISCONNECTED', 'SOCKET_STATUS'], value: false },
    { type: ['PAPER_NOT_PRESENT', 'PRINTER_STATUS'], value: false },
    { type: ['DISCONNECTED', 'PRINTER_STATUS'], value: false }
  ];
  checkboxesForm = new FormGroup({});
  updateAlertMaintenanceSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private snackbarService: SnackBarService) {
                this.JSON = JSON;
              }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges() {
    if (this.alert) {
      this.resetForm();
    }
  }

  public duallistboxOutputEventReceiver(sections) {
    const aux = new Array();
    for (const d of sections) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.alert.centerAlertApplications = aux;
      this.updateMaintenanceAlert();
    }
  }

  public checkboxListener(checkbox) {
    this.updateMaintenanceAlert();
  }

  private updateMaintenanceAlert() {
    this.updateAlertMaintenanceSubscription = this.eventsService.updateAlertAlertTypes(this.alert.InternalId, this.parseFormValues(this.checkboxesForm)).pipe(
      tap(o => this.eventsService.refreshAlert()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private createForm() {
    this.maintenanceAlerts.forEach(
      (ma) => {
        this.checkboxesForm.addControl(JSON.stringify(ma.type), new FormControl(ma.value, Validators.required));
      }
    );
  }

  private resetForm() {
    this.alert.centerAlertDeviceList.forEach(
      (entry) => {
        this.checkboxesForm.patchValue({
          [JSON.stringify([entry['alertValue'], entry['alertType']])]: true
        });
      }
    );
  }

  private parseFormValues(form) {
    const activeControls = [];
    Object.entries(form.controls).forEach(
      (control) => {
        if (control[1]['value'] === true) {
          activeControls.push({ alertValue: JSON.parse(control[0])[0], alertType: JSON.parse(control[0])[1] });
        }
      }
    );
    return activeControls;
  }

}
